import { CountryCode } from './countries'
import { ProjectCode } from './projects'

export type CustomerServiceUrlMap = Partial<Record<ProjectCode, Partial<Record<CountryCode, string>>>>

export const CUSTOMER_SERVICE_URLS: CustomerServiceUrlMap = {
  [ProjectCode.DCS]: {
    [CountryCode.TW]: 'https://page.line.me/DOGCATSTAR',
    [CountryCode.HK]: 'https://page.line.me/DOGCATSTAR',
    [CountryCode.SG]: 'https://page.line.me/DOGCATSTAR',
    [CountryCode.MY]: 'https://page.line.me/DOGCATSTAR',
  },
  [ProjectCode.LM]: {
    [CountryCode.TW]: 'https://page.line.me/LitoMon',
    [CountryCode.HK]: 'https://page.line.me/LitoMon',
  },
  [ProjectCode.HM]: {
    [CountryCode.TW]: 'https://page.line.me/HEROMAMA',
    [CountryCode.HK]: 'https://page.line.me/HEROMAMA',
  },
  [ProjectCode.MNP]: {
    [CountryCode.TW]: 'https://lin.ee/q6KXRGA',
    [CountryCode.HK]: 'https://lin.ee/q6KXRGA',
    [CountryCode.US]: 'mailto:service@ladynpet.com',
  },
  [ProjectCode.RS]: {
    [CountryCode.TW]: 'https://link.rihshin.com/6e7354a0',
  },
  [ProjectCode.AQUA]: {
    [CountryCode.TW]: 'https://page.line.me/642aaeli?openQrModal=true',
    [CountryCode.HK]: 'https://page.line.me/642aaeli?openQrModal=true',
  },
  [ProjectCode.YT]: {
    [CountryCode.TW]: 'https://page.line.me/967ugdqd',
  },
}
